import HotelBillingPage from '@/pages/HotelBillingPage';
import { WalletAddresses } from '@/components/WalletAddresses';

export function BillingTab({ hotelId }) {
  return (
    <div className="space-y-6" data-testid="owner-billing-content">
      <div>
        <h2 className="text-2xl font-bold heading-font mb-2">Finance & Billing</h2>
        <p className="text-muted-foreground">View billing, payments, revenue, and configured wallet addresses</p>
      </div>
      
      <HotelBillingPage hotelId={hotelId} />
      <WalletAddresses hotelId={hotelId} readOnly={true} />
    </div>
  );
}
